import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { buildCanonicalUrl } from '../seo/seoConfig';

export const useCanonicalUrl = (pathOverride) => {
  const location = useLocation();

  return useMemo(() => {
    const path = pathOverride || `${location.pathname}${location.search || ''}`;
    return buildCanonicalUrl(path);
  }, [location.pathname, location.search, pathOverride]);
};

